import axios from 'axios'
import rulesHandler from '../../rulesHandler'

const state = {
  items: [],
  sports: [],
  sportsBestPlayed: [],
}

const getters = {
  getItems(state, getters) {
    return state.items
  },
  getSports(state, getters) {
    return state.sports
  },

  getSportsBestPlayed(state, getters) {
    return state.sportsBestPlayed
  },
}

const actions = {
  //fetchCategories: (context, payload) => (paramKey) =>  {
  actionSportLive(context, payload) {
    //console.log(context.state.sports);
    context.state.sports[payload.index].detail = payload.detail
  },
  actionSportActive(context, payload) {
    // console.log(payload);
    context.state.sports[payload.index].active = payload.active
  },
  filterSport(context, payload) {
    // Filtro gli items da mostrare
    context
      .dispatch('filterItems', {
        items: context.state.sports,
        lang: payload.language,
      })
      .then(items => {
        context.commit('setItems', items)
      })
  },

  async fetchSports(context, payload) {
    const request = {
      language:
        payload != undefined && payload.language != undefined
          ? payload.language
          : undefined,
    }

    const urlsport = `${context.rootGetters['settings/getUrlApi']}/api/get-sports-front`

    await axios
      .post(`${urlsport}`, request, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      .then(res => {
        // Applico le regole
        //console.log(res.data.data)
        context.dispatch('applyRules', res.data.data).then(items_with_rules => {
          //console.log("items_with_rules",items_with_rules)
          //console.log(_.find(items_with_rules,{id:1220243093}))
          // Salvo gli elementi con le regole applicate
          context.commit('setSports', items_with_rules)
          const listitems = _.filter(items_with_rules, { active: true })
          // Filtro gli items da mostrare

          //    context.commit('setItems',listitems);
          //console.log(payload)
          context
            .dispatch('filterItems', {
              items: listitems,
              lang: payload.language,
            })
            .then(items => {
              //    console.log("items",items)
              context.commit('setItems', items)
            })
        })
      })
      .catch(err => {
        console.log(err)

        /*if(err.response.status===401){
                    this.setLogout();
                    this.$router.push('/login')
                }*/
      })
  },
  /* todo use this when ready to production
    async fetchSports(context, payload) {

        // let request = {
        //     language: (payload != undefined && payload.language != undefined) ? payload.language : undefined,
        //
        // }

        // let urlsport = `${context.rootGetters['settings/getUrlApi']}/api/get-sports-front`;
        //
        // await axios.post(`${urlsport}`, request, {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}})
        //
        //     .then(res => {
        //
        //         // Applico le regole
        //         //console.log(res.data.data)
        //         context.dispatch('applyRules', res.data.data).then((items_with_rules) => {
        //             //console.log("items_with_rules",items_with_rules)
        //             //console.log(_.find(items_with_rules,{id:1220243093}))
        //             // Salvo gli elementi con le regole applicate
        //             context.commit('setSports', items_with_rules);
        //             var listitems = _.filter(items_with_rules, {active: true})
        //             // Filtro gli items da mostrare
        //
        //             //    context.commit('setItems',listitems);
        //             //console.log(payload)
        //             context.dispatch('filterItems', {items: listitems, lang: payload.language}).then((items) => {
        //                 //    console.log("items",items)
        //                 context.commit('setItems', items);
        //
        //             })
        //
        //         })
        //
        //
        //     })
        //     .catch(err => {
        //         console.log(err);
        //

        //     });


        //todo take from configuration the folder name -> Production/ Develop/ Local
        const cloudfrontDistribution = process.env.VUE_APP_URL_CLOUDFRONT;

        let urlsportCloudfront = `${cloudfrontDistribution}/sports-front/sport_front_${payload.language}.json`;

        await axios.get(`${urlsportCloudfront}`)

            .then(res => {

                // Applico le regole
                //console.log(res.data.data)
                context.dispatch('applyRules', res.data.data).then((items_with_rules) => {
                    //console.log("items_with_rules",items_with_rules)
                    //console.log(_.find(items_with_rules,{id:1220243093}))
                    // Salvo gli elementi con le regole applicate
                    context.commit('setSports', items_with_rules);
                    var listitems = _.filter(items_with_rules, {active: true})
                    // Filtro gli items da mostrare

                    //    context.commit('setItems',listitems);
                    //console.log(payload)
                    context.dispatch('filterItems', {items: listitems, lang: payload.language}).then((items) => {
                        //    console.log("items",items)
                        context.commit('setItems', items);

                    })

                })


            })
            .catch(err => {
                console.log(err);
            });

    },*/

  async filterItems(context, payload) {
    const items_filtered = []

    await _.forEach(payload.items, function (item) {
      const response = _.find(item.detail, { lang: payload.lang })
      const textDesc =
        response !== undefined ? response.text : '*' + item.detail[0].text
      items_filtered.push({
        id: item.id,
        name: textDesc,
        _id: item._id,
        detail: item.detail,
        active: item.active,
        order: item.order,
      })
    })

    return _.sortBy(items_filtered, ['order', 'name'])
  },

  async applyRules(context, items) {
    const scope = 'sport'
    let onlyManager = true
    //console.log("id",context.rootGetters['settings/getPlatformId'])
    //console.log("id",context.rootGetters['rules/getRulesSkin'])
    //console.log("list",context.rootGetters['skins/getList'])

    if (context.rootGetters['settings/getPlatformId'] > 0) {
      onlyManager = false
      //console.log("context.rootGetters['rules/getRulesSkin']",context.rootGetters['rules/getRulesSkin'])
      //var skinDetail = _.find(context.rootGetters['rules/getRulesSkin'], {"platform_id":context.rootGetters['settings/getPlatformId']})
      var skinDetail = context.rootGetters['rules/getRulesSkin']
    }

    //console.log(context.rootGetters['skins/getList'])

    const checkRules = _.filter(context.rootGetters['rules/getRulesManager'], {
      scope: scope,
    })
    //console.log(checkRules)
    if (checkRules.length > 0) {
      // console.log('Applico Regole Manager Sports')

      const rulesManager = _.groupBy(checkRules, 'type')

      await rulesHandler.applyRules(rulesManager, items)
    } else {
      // console.log('Sport: Nessuna regola per il Manager')
    }

    if (!onlyManager) {
      //console.log("skinDetail",skinDetail)
      const checkRulesSkin = _.filter(skinDetail, { scope: scope })
      //console.log("checkRulesSkin",checkRulesSkin)
      if (checkRulesSkin.length > 0) {
        // console.log('Applico Regole Sports Skin ID: '+context.rootGetters['rules/getPlatformId'])

        const rulesSkin = _.groupBy(checkRulesSkin, 'type')
        //console.log("rulesSkin",rulesSkin)
        /*  console.log("items",items)*/
        await rulesHandler.applyRules(rulesSkin, items)
      } else {
        // console.log('Sport: Nessuna regola per la Skin')
      }
    }
    //console.log(items)

    return items
  },
  async getSportFrom_IdSport(context, payload) {
    const sports = context.rootGetters['sport/getSports']

    const sportFound = sports.filter(sport => {
      return sport._id == payload._id
    })

    if (sportFound.length > 0) {
      return sportFound[0]
    } else {
      return null
    }
  },
  async setSportsBestPlayedAct(context, payload) {
    context.commit('setSportsBestPlayed', payload)
  },

  async setReceiptPrinted(context, payload) {
    const requestPayload = {
      platformId: +context.rootGetters['settings/getPlatformId'],
    }

    if (payload.betCode != null) {
      requestPayload.betCode = payload.betCode
    }
    if (payload.code != null) {
      requestPayload.code = payload.code
    }

    const url = `${context.rootGetters['settings/getBetApiUrl']}/receipt/print`

    return await axios
      .post(`${url}`, requestPayload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })
      .then(async res => {
        // console.log('res')
        // console.log(res)
      })
      .catch(error => {
        console.log(error)
      })
  },
  async fetchMarketGuideQuickbet(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/sports/guide/quickbets/platforms/${context.rootGetters['settings/getPlatformId']}/language/${context.rootGetters['settings/getLanguage']}/get-markets-guide-quickbet`

    return axios
      .get(`${url}`, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      .then(async res => {
        return res.data
      })
      .catch(err => {
        console.log(err)
      })
  },
}

const mutations = {
  setItems(state, payload) {
    state.items = payload
  },
  setSports(state, payload) {
    state.sports = payload
  },

  setSportsBestPlayed(state, payload) {
    state.sportsBestPlayed = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
